import { VerifiedBundle } from '@frontend/bundle/types';

export type BundleUsageSeverity = 'warning' | 'critical';

export interface BundleUsageBannerState {
    severity: BundleUsageSeverity;
    usage: number;
    quantity: number;
    percent: number;
}

export function resolveBundleUsageBanner(bundles: VerifiedBundle[]): BundleUsageBannerState | null {
    let best: BundleUsageBannerState | null = null;

    for (const bundle of bundles) {
        if (bundle.quantity == null || bundle.quantity <= 0) {
            continue;
        }

        const ratio = bundle.usage / bundle.quantity;
        if (ratio < 0.8) {
            continue;
        }

        const candidate: BundleUsageBannerState = {
            severity: ratio >= 1 ? 'critical' : 'warning',
            usage: bundle.usage,
            quantity: bundle.quantity,
            percent: Math.round(ratio * 100)
        };

        if (!best || isMoreSevere(candidate, best)) {
            best = candidate;
        }
    }

    return best;
}

function isMoreSevere(candidate: BundleUsageBannerState, current: BundleUsageBannerState): boolean {
    if (candidate.severity === 'critical' && current.severity === 'warning') {
        return true;
    }
    return candidate.severity === current.severity && candidate.percent > current.percent;
}
